import { ActionType } from '../../types/action';

const listPermission = {
  resource: 'thrift-company-groups',
  action: ActionType.READ,
};

const createPermission = {
  resource: 'thrift-company-group',
  action: ActionType.CREATE,
};

const updatePermission = {
  resource: 'thrift-company-group',
  action: ActionType.UPDATE,
};

const readPermission = {
  resource: 'thrift-company-group',
  action: ActionType.READ,
};

const deletePermission = {
  resource: 'thrift-company-group',
  action: ActionType.DELETE,
};

export const CompanyGroup = {
  list: listPermission,
  read: readPermission,
  create: createPermission,
  update: updatePermission,
  delete: deletePermission,
};
